export function Spinner({ className = '' }: { className?: string }) {
    return <div className={'w-6 h-6 border-3 border-light-grey border-t-black rounded-full animate-spin ' + className} />;
}
